import React, { createContext, useState, useContext, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    // Rafraîchit le statut du membre depuis le backend (source de vérité).
    // Renvoie l'objet à jour, ou null si non connecté / erreur.
    const refreshStatus = async () => {
        const token = localStorage.getItem('token');
        if (!token) return null;
        try {
            const response = await api.get('/auth/me');
            const fresh = response.data;
            // On fusionne avec ce qu'on avait (garde first_name, photo_url du login)
            const saved = JSON.parse(localStorage.getItem('user') || '{}');
            const merged = { ...saved, ...fresh };
            localStorage.setItem('user', JSON.stringify(merged));
            setUser(merged);
            return merged;
        } catch (err) {
            // Token invalide/expiré : on déconnecte proprement
            if (err.response && err.response.status === 401) {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                setUser(null);
            }
            return null;
        }
    };

    useEffect(() => {
        const token = localStorage.getItem('token');
        const savedUser = localStorage.getItem('user');
        if (token && savedUser) {
            setUser(JSON.parse(savedUser));
        }
        // Puis on va chercher le statut frais (validation, etc.)
        refreshStatus().finally(() => setLoading(false));
    }, []);

    const login = async (email, password) => {
        const response = await api.post('/auth/login', { email, password });
        const { token, user } = response.data;
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(user));
        setUser(user);
        return user;
    };

    const register = async (email, password, gender) => {
        const response = await api.post('/auth/register', { email, password, gender });
        return response.data;
    };

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setUser(null);
        window.location.href = '/login';
    };

    return (
        <AuthContext.Provider value={{ user, login, register, logout, loading, refreshStatus }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);